import React from 'react';
import { isoToMonthDateYear } from '../../../helpers/helpers';
import StatusChip from '../../../Components/StatusChip';

const CampaignListCard = ({ cardDetails, onClick, className, campaignStatus }) => {
    return (
        <div className={`campaign-card campaign-list-card ${className}`} onClick={onClick}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h4>{cardDetails.title}</h4>

                {campaignStatus === "All" && <span style={{ alignContent: "center" }}>
                    <StatusChip
                        value={cardDetails.status}
                        color={{
                            "Pending": "yellow",
                            "Finished": "orange",
                            "Active": "green"
                        }[cardDetails.status]} />
                </span>}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: "12px" }}>
                <div>
                    <h5 style={{ color: "gray", fontWeight: '500', margin: 0 }}>Start Campaign Date</h5>
                    <div style={{ marginTop: "4px" }}>{isoToMonthDateYear(cardDetails.startCampaignDate)}</div>
                </div>
                <div>
                    <h5 style={{ color: "gray", fontWeight: '500', margin: 0 }}>End Campaign Date</h5>
                    <div style={{ marginTop: "4px" }}>{isoToMonthDateYear(cardDetails.endCampaignDate)}</div>
                </div>

            </div>
        </div>
    );
}

export default CampaignListCard;
